import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { AppActions, AppActionTypes } from './actions';
import { LegalNitrogenWorkingCoefficient, LegalNitrogenWorkingCoefficientsState } from '../shared/models';

export const legalNitrogenWorkingCoefficientsAdapter: EntityAdapter<LegalNitrogenWorkingCoefficient> = createEntityAdapter<LegalNitrogenWorkingCoefficient>();
export const initialLegalNitrogenWorkingCoefficientsState: LegalNitrogenWorkingCoefficientsState = legalNitrogenWorkingCoefficientsAdapter.getInitialState({});

export function legalNitrogenWorkingCoefficientsReducer(
  state = initialLegalNitrogenWorkingCoefficientsState,
  action: AppActions,
): LegalNitrogenWorkingCoefficientsState {
  switch (action.type) {
    case AppActionTypes.LoadLegalNitrogenWorkingCoefficientsSuccess: {
      const removedState = legalNitrogenWorkingCoefficientsAdapter.removeAll(state);
      return legalNitrogenWorkingCoefficientsAdapter.upsertMany(action.legalNitrogenWorkingCoefficients, removedState);
    }

    case AppActionTypes.UpsertLegalNitrogenWorkingCoefficientSuccess: {
      return legalNitrogenWorkingCoefficientsAdapter.upsertOne(action.legalNitrogenWorkingCoefficient, state);
    }

    case AppActionTypes.DeleteLegalNitrogenWorkingCoefficientSuccess: {
      return legalNitrogenWorkingCoefficientsAdapter.removeOne(action.legalNitrogenWorkingCoefficient.id, state);
    }

    default: {
      return state;
    }
  }
}
